"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));

var _FieldLanguage = _interopRequireDefault(require("./FieldLanguage"));

require("./FieldInput.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class FieldInput extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onBlur", event => {
      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    });

    _defineProperty(this, "onFocus", event => {
      if (this.props.onFocus) {
        this.props.onFocus(event);
      }
    });

    _defineProperty(this, "onChange", event => {
      const value = event.target.value;
      this.setState({
        value: value
      });

      if (this.props.onChange) {
        this.props.onChange(value, event);
      }
    });

    _defineProperty(this, "getClassName", () => {
      const _this$props = this.props,
            className = _this$props.className,
            type = _this$props.type;
      let classNames = [];
      classNames.push('admin-field__input');

      if (type) {
        classNames.push('admin-field__input--' + type);
      }

      return classNames.join(' ');
    });

    this.state = {
      value: props.value
    };
  }

  render() {
    const _this$props2 = this.props,
          id = _this$props2.id,
          language = _this$props2.language,
          type = _this$props2.type,
          value = _this$props2.value,
          readonly = _this$props2.readonly,
          disabled = _this$props2.disabled,
          placeholder = _this$props2.placeholder,
          pattern = _this$props2.pattern,
          rows = _this$props2.rows,
          step = _this$props2.step,
          min = _this$props2.min,
          max = _this$props2.max;
    const className = this.getClassName();

    if (rows) {
      return _react.default.createElement("div", {
        className: className
      }, _react.default.createElement(_FieldLanguage.default, {
        language: language
      }), _react.default.createElement(_reactTextareaAutosize.default, {
        id: id,
        placeholder: placeholder,
        readOnly: readonly,
        rows: rows,
        value: value,
        onFocus: event => this.onFocus(event),
        onBlur: event => this.onBlur(event),
        onChange: event => this.onChange(event)
      }));
    }

    return _react.default.createElement("div", {
      className: className
    }, _react.default.createElement(_FieldLanguage.default, {
      language: language
    }), _react.default.createElement("input", {
      id: id,
      type: type,
      placeholder: placeholder,
      pattern: pattern,
      disabled: disabled,
      readOnly: readonly,
      value: value,
      step: step,
      min: min,
      max: max,
      onFocus: event => this.onFocus(event),
      onBlur: event => this.onBlur(event),
      onChange: event => this.onChange(event)
    }));
  }

}

_defineProperty(FieldInput, "defaultProps", {
  type: "text",
  value: "",
  required: false,
  autofocus: false
});

var _default = FieldInput;
exports.default = _default;
module.exports = exports.default;